import { render, staticRenderFns } from "./FileConfigRoleModal__Style#Drawer.vue?vue&type=template&id=52e8c1c1&scoped=true&"
import script from "./FileConfigRoleModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./FileConfigRoleModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./FileConfigRoleModal__Style#Drawer.vue?vue&type=style&index=0&id=52e8c1c1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e8c1c1",
  null
  
)

export default component.exports